import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateFormatService {

  dateFormat = "yyyy-MM-dd - hh:mm a"
  fullDateFormat = "yyyy-MM-dd - hh:mm:ss a"
  dateOnlyFormat = "yyyy-MM-dd"
  timeOnlyFormat = "hh:mm a"
  fullTimeOnlyFormat = "hh:mm:ss a"
  
  constructor() { }


}
